var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M9.06 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h3.06m0-18H18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H9.06m0-18v18m-3-14.5v4.9m9.52-3.08L12 11.91m0 0 3.58 3.58M12 11.91h6.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideOut);
export default __webpack_public_path__ + "static/media/side_out.adfddebefcc3b30d38f20049db415baa.svg";
export { ForwardRef as ReactComponent };